import moment from 'moment';
import { CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP } from '../../library/ContratoEntePublicoAcaoAvalia';
import { CONTRATO_STATUS_EM_EDICAO } from '../../library/ContratoStatus';
import { CONTRATO_TIPO_ENTE_PUBLICO } from '../../library/ContratoTipos';
import { CONTRATO_VERSAO_CONTRATO } from '../../library/ContratoVersoes';
import { getHistoricoArrayNormalized } from '../../utils/ContratoUtils';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import {
  CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION,
  CLEARED_CONTRATO_ENTE_PUBLICO_ACTION,
  LOADED_CONTRATO_ENTE_PUBLICO_ACTION,
  LOADED_CONTRATO_ENTE_PUBLICO_ARQUIVOS,
  LOADED_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
  LOADING_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION,
  LOADING_CONTRATO_ENTE_PUBLICO_ARQUIVOS,
  LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL,
} from './ContratosEntePublicoActions';

const CONTRATO_EDITING_NOT_NULL_PROPS = [
  'codCoop',
  'codigo',
  'dataFim',
  'dataInicio',
  'dataDistrato',
  'emailCoop',
  'nomCidade',
  'flgAnaliseJuridica'
];

const CONTRATO_EDITING_INITIAL_STATE = {
  codCoop: '',
  codigo: '',
  dataFim: '',
  dataInicio: '',
  dataDistrato: '',
  emailCoop: '',
  idEstado: 0,
  programasEducacionais: [],
  nomCidade: '',
  totalMeses: 0,
  flgAnaliseJuridica: false,
  idContrato: null,
  idAditivo: null,
  idDistrato: null,
  tipoContrato: CONTRATO_TIPO_ENTE_PUBLICO,
  versaoContrato: CONTRATO_VERSAO_CONTRATO,
  flgStatus: -1,
  ativo: true,
  historicoAnaliseOperacional: [],
  arquivos: null,

  ultimaAvaliaEnviado: {
    id: null,
    comentario: null,
    acaoAvalia: -1,
    acaoAvaliaValue: null,
    flgPrincipal: false,
    datAlteracao: null,
    extensaoArquivo: null,
    caminho: null,
  },

  avaliaAprovada: {
    id: null,
    comentario: null,
    acaoAvalia: -1,
    acaoAvaliaValue: null,
    flgPrincipal: false,
    datAlteracao: null,
    extensaoArquivo: null,
    caminho: null,
  },
};

const INITIAL_STATE = {
  loadingArquivos: false,
  loadingAlteraArquivo: false,
  loadingAlteraStatus: false,
  loadingHistoricoAnaliseOperacional: false,
  contratoEditing: CONTRATO_EDITING_INITIAL_STATE,
};

export default function ContratosEntePublicoReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case CLEARED_CONTRATO_ENTE_PUBLICO_ACTION:
      return { ...state, contratoEditing: CONTRATO_EDITING_INITIAL_STATE };
    case LOADED_CONTRATO_ENTE_PUBLICO_ACTION:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...action.payload,
            historicoAnaliseOperacional:
              CONTRATO_EDITING_INITIAL_STATE.historicoAnaliseOperacional,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case CHANGED_CONTRATO_ENTE_PUBLICO_EDITING_VALUE_ACTION:
      return {
        ...state,
        contratoEditing: {
          ...state.contratoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case LOADING_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL:
      return { ...state, loadingHistoricoAnaliseOperacional: action.payload };
    case LOADED_CONTRATO_ENTE_PUBLICO_HISTORICO_ANALISE_OPERACIONAL: {
      let historico = getHistoricoArrayNormalized(
        action.payload
          .map((item) => {
            if (!item.justificativa) {
              return null;
            }
            return {
              ...item,
              isAnaliseOperacional:
                item.acaoAvaliaValue === CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP
                  ? false
                  : true,
              nome: item.nome || 'teste',
              datAlteracao: moment(
                item.datAlteracao,
                'DD MM YYYY HH mm ss'
              ).format('YYYY MM DD HH:mm:ss'),
            };
          })
          .filter((item) => (item ? true : false)),
        'datAlteracao',
        'id',
        'isAnaliseOperacional',
        'comentario',
        'nome'
      );
      if (
        historico &&
        historico.length === 1 &&
        historico[0].acaoAvaliaValue ===
        CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_COOP &&
        state.contratoEditing.flgStatus === CONTRATO_STATUS_EM_EDICAO
      ) {
        historico = [];
      }
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            historicoAnaliseOperacional: historico,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    }
    case LOADING_CONTRATO_ENTE_PUBLICO_ARQUIVOS:
      return { ...state, loadingArquivos: action.payload };
    case LOADED_CONTRATO_ENTE_PUBLICO_ARQUIVOS:
      return {
        ...state,
        contratoEditing: transformNullIntoEmpty(
          {
            ...state.contratoEditing,
            arquivos: action.payload,
          },
          CONTRATO_EDITING_NOT_NULL_PROPS
        ),
      };
    case LOADING_CONTRATO_ENTE_PUBLICO_ALTERA_STATUS_ACTION:
      return {
        ...state,
        loadingAlteraStatus: action.payload,
        loadingAlteraArquivo: action.payload,
      };
    default:
      return state;
  }
}
